import React, { useRef, useState, useEffect,useCallback } from 'react';
import { ImageInput, ImageField, useNotify, FileInput, FileField, required } from 'react-admin';
import { Form } from 'react-final-form'
import Button from '@material-ui/core/Button';
import SendIcon from '@material-ui/icons/Send';
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import _ from 'lodash';
import axios from 'axios'

const ChooseFile = (props) => {

  const [fileList, setFileList] = useState();

  const { isImage, openChooseImageDialog, 
    openChooseImageDialogFn, idDetFact,refreshMessageList } = props;
  const notify = useNotify();

  const changed =(e) => {
    e.preventDefault();
    if(e && e.target) setFileList(e.target.files);
  }

  const upload = (url) => {
    var formData = new FormData();

    for(var index = 0; index < fileList.length; index++) {
      formData.append("files", fileList[index]);
    }

    const config = {
      method: 'post',
      url: url,
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": "Bearer "+ localStorage.getItem('token')
      },
      data: formData
    };

    axios(config).then(function (response) {
                if(response.data.status==='success'){
                  refreshMessageList();
                  notify(response.data.message);
                }else{
                  notify(response.data.message,'warning');
                }
                  
                  
                })
                .catch(function (error) {
                  notify(error.message,'warning');
                });
  }

  const handleSubmit =() => {

    if(fileList && fileList.length>4){
      notify('Vous ne pouvez pas envoyer plus de 4 fichiers en même temps !','warning');
      return null;
    } 
    openChooseImageDialogFn();
    if(fileList){
      var formData = new FormData();

      for(var index = 0; index < fileList.length; index++) {
        formData.append("files", fileList[index]);
      }

      upload(process.env.REACT_APP_URL + '/aerien/add_file_bu/'+idDetFact);
    }
  };

  return (

    <span>

      <Dialog
        open={openChooseImageDialog}
        onClose={() => openChooseImageDialogFn()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">
          Chosir une image
        </DialogTitle>
        <DialogContent dividers>
          <Form 
            onSubmit={(e) => handleSubmit(e)}
            render={({ handleSubmit }) => (
              <form   onChange={(event) => changed(event)}>
                {
                  isImage ?  
                  <ImageInput source='files' maxSize={10000000}  label="Images selectionnées" multiple accept="image/png, image/jpg,image/gif, image/jpeg" validate={required()} >
                    <ImageField source='src' title="preview" />
                  </ImageInput>
                  :
                  <FileInput source="files" maxSize={10000000}  label="Fichiers selectionnés" multiple accept="application/pdf" validate={required()} >
                        <FileField source="src" title="preview" />
                  </FileInput>
                }
              </form>
            )} />

        </DialogContent>
        <DialogActions>
                <Button onClick={() => openChooseImageDialogFn()} color="primary" autoFocus >Annuler</Button>
                <Button color="primary" onClick={handleSubmit} autoFocus ><SendIcon />Envoyer</Button>
        </DialogActions>
      </Dialog>
    </span>
  );
}

export default ChooseFile;
